import {
  RecipientPotentiallyUnknownOrg,
  RecipientUser,
} from "../../../../../domain/RecipientsViewModel";

export type OrgAction =
  | {
      type: "FLAG_ORG";
      payload: { orgId: string; isToDelete: boolean };
    }
  | {
      type: "FLAG_USER";
      payload: { orgId: string; userId: string; isToDelete: boolean };
    }
  | { type: "FLAG_ALL_ORGS"; payload: { isToDelete: boolean } }
  | { type: "ADD_ORG"; payload: RecipientPotentiallyUnknownOrg }
  | { type: "ADD_USER"; payload: { orgId: string; user: RecipientUser } }
  | { type: "ADD_ALL_ORGS", payload: RecipientPotentiallyUnknownOrg[] }
  | { type: "REMOVE_SELECTED" };

export const reducer = (
  orgs: RecipientPotentiallyUnknownOrg[],
  action: OrgAction
) => {
  
  switch (action.type) {
    case "FLAG_ORG": {
      const { orgId, isToDelete } = action.payload;
      return orgs.map((org) =>
        org.id === orgId
          ? {
            ...org,
            isToDelete: isToDelete,
            users: org.users.map((user) => ({ ...user, isToDelete })),
          }
          : org
      );
    }
    case "FLAG_USER": {
      const { isToDelete, userId, orgId } = action.payload;
      return orgs.map((org) =>
        org.id === orgId
          ? {
            ...org,
            // if the user is being made undeleted, then the org must be undeleted too
            isToDelete: isToDelete ? org.isToDelete : false,
            users: org.users.map((user) =>
              user.id === userId ? { ...user, isToDelete } : user
            ),
          }
          : org
      );
    }
    case "FLAG_ALL_ORGS": {
      const { isToDelete } = action.payload;
      return orgs.map((org) => ({
        ...org,
        users: org.users.map((user) => ({ ...user, isToDelete })),
        isToDelete,
      }));
    }
    case "ADD_ORG": {
      return [...orgs, action.payload];
    }

    case "ADD_USER": {
      const { orgId, user } = action.payload;
      return orgs.map((org) =>
        org.id === orgId ? { ...org, users: [...org.users, user] } : org
      );
    }

    case "REMOVE_SELECTED": {
      return orgs
        .filter((org) => !org.isToDelete)
        .map((org) => ({
          ...org,
          users: org.users.filter((user) => !user.isToDelete),
        }));
    }

    case "ADD_ALL_ORGS":
    {
      //merge any existing organisation settings
      var merged = action.payload.map((org) =>
      {
        const foundIndex = orgs.findIndex((x) => x.id === org.id)
        if (foundIndex !== -1) {
          org = { ...orgs[foundIndex] };
        }
        return org;
      })
      return merged
    }
     

    default:
      return orgs;
  }
};
